import { PayableTypes } from '@efex-services/client/types';
import { Alert } from '@efexteam/components';
import ALLOWED_STATUS from '@pages/transferDetails/constants/allowedStatus';
import TransferDetailsStyles from '@pages/transferDetails/TransferDetails.style';
import { MovementAlertProps } from '@pages/transferDetails/types';
import { useTranslation } from 'react-i18next';

const MovementAlert = ({
  remainingTime,
  timeValues,
  status,
}: MovementAlertProps) => {
  const { minutes, hours } = timeValues;
  const { t } = useTranslation();

  if (!ALLOWED_STATUS.includes(status)) {
    return null;
  }

  if (
    minutes > 0 &&
    hours > 0 &&
    status === PayableTypes.PENDING_TO_APPROVE_BY_USER
  ) {
    return (
      <Alert severity="info" className={TransferDetailsStyles.alert}>
        {t('trsfDtlAlert', {
          remaining: remainingTime,
        })}
      </Alert>
    );
  }

  return (
    <Alert
      severity="warning"
      variant="outlined"
      className={TransferDetailsStyles.alert}
    >
      {t('trsfDtlAlertExpired')}
    </Alert>
  );
};

export default MovementAlert;
